import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { promptLibraryApiRef, PromptLibraryClient } from './api';
import { rootRouteRef, promptRouteRef, agentRouteRef } from './routes';

export const promptLibraryPlugin = createPlugin({
  id: 'prompt-library',
  routes: {
    root: rootRouteRef,
    prompt: promptRouteRef,
    agent: agentRouteRef,
  },
  apis: [
    createApiFactory({
      api: promptLibraryApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new PromptLibraryClient({ fetchApi, discoveryApi, identityApi }),
    }),
  ],
});

export const PromptLibraryPage = promptLibraryPlugin.provide(
  createRoutableExtension({
    name: 'PromptLibraryPage',
    component: () =>
      import('./components/PromptLibraryPage').then(m => m.PromptLibraryPage),
    mountPoint: rootRouteRef,
  }),
);
